import { ConnectionNames } from "../Contracts";
import { connectSportsWithToken } from "../C_Sportsbook/Helpers";
export const ConnectWithToken = {
    [ConnectionNames.sports]: connectSportsWithToken,
};
//# sourceMappingURL=ConnectWithToken.js.map